import { render, staticRenderFns } from "./Basicinfo.vue?vue&type=template&id=377224b0&scoped=true"
import script from "./Basicinfo.vue?vue&type=script&lang=js"
export * from "./Basicinfo.vue?vue&type=script&lang=js"
import style0 from "./Basicinfo.vue?vue&type=style&index=0&id=377224b0&prod&lang=scss"
import style1 from "./Basicinfo.vue?vue&type=style&index=1&id=377224b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377224b0",
  null
  
)

export default component.exports